interface EmptyStateProps {
  title: string;
  description: string;
  icon?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
}

export default function EmptyState({
  title,
  description,
  icon = "ri-inbox-line",
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 flex items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-600"
        >
          <i className="ri-refresh-line text-base" />
          {actionLabel}
        </button>
      )}
    </div>
  );
}